export class SecurityHelper {
  public static initFrameBuster() {
    function frameBuster() {
      if (window.top && window.top !== window.self) {
        window.top.location = window.self.location.toString();
      }
    }

    window.addEventListener('DOMContentLoaded', frameBuster);
    window.addEventListener('load', frameBuster);
    window.addEventListener('resize', frameBuster);
  }
}
